import React from 'react';
import { ChevronUpIconSmall, ChevronDownIconSmall } from '@domain-group/fe-co-icon';
import * as styles from './quick-links-toggle-button.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var QuickLinksToggleButton = _ref => {
  var toggleQuickLinks = _ref.toggleQuickLinks,
    isQuickLinksShown = _ref.isQuickLinksShown;
  var buttonText = isQuickLinksShown ? 'Less' : 'More';
  var Icon = isQuickLinksShown ? ChevronUpIconSmall : ChevronDownIconSmall;
  return ___EmotionJSX("button", {
    css: styles.button,
    onClick: toggleQuickLinks,
    type: "button"
  }, ___EmotionJSX("span", {
    id: "text"
  }, buttonText), ___EmotionJSX(Icon, null));
};